import { Button } from "@hortis/ui/button";
import {
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@hortis/ui/dialog";
import { toast } from "@hortis/ui/sonner";
import { namedOperations, useArchiveMaterialMutation } from "generated/graphql";
import { queryClient } from "src/app";

export const TrashMaterialDialogContent = ({
  id,
  onSuccess: onSuccessProp,
}: {
  id: string;
  onSuccess?: () => void;
}) => {
  const [{ fetching }, archiveMaterial] = useArchiveMaterialMutation();

  const handleSubmit = async () => {
    const res = await archiveMaterial({
      materialId: id,
    });
    queryClient.invalidateQueries({
      queryKey: [namedOperations.Query.GetMaterial],
    });

    if (res.data?.archivePlantMaterial?.__typename !== "PlantMaterial") {
      toast.error("Failed to trash material");
      return;
    }

    toast.success("Successfully trashed material");
    onSuccessProp?.();
  };

  return (
    <DialogContent data-cy="trash-material-dialog">
      <DialogHeader>
        <DialogTitle>Move to trash?</DialogTitle>
        <DialogDescription>
          This will move 1 plant material record to your site trash.
        </DialogDescription>
      </DialogHeader>
      <DialogFooter>
        <DialogClose asChild>
          <Button size="lg" fullWidth testId="trash-material-cancel">
            Cancel
          </Button>
        </DialogClose>
        <Button
          size="lg"
          onClick={handleSubmit}
          loading={fetching}
          variant="warning"
          fullWidth
          testId="trash-material-button"
        >
          Move to trash
        </Button>
      </DialogFooter>
    </DialogContent>
  );
};
